import { render } from "./CardSelection.vue?vue&type=template&id=45675965"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"

import "./CardSelection.vue?vue&type=style&index=0&id=45675965&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__